import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { format } from 'date-fns';
import { supabase } from '@/api/supabaseClient';
import { Calendar, Clock, User } from 'lucide-react';

export default function BlockTimeDialog({ date, installer, onClose }) {
  const [startTime, setStartTime] = useState('8:00 AM');
  const [endTime, setEndTime] = useState('5:00 PM');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const timeOptions = [
    '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM',
    '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM'
  ];

  const handleBlock = async () => {
    setLoading(true);

    const { error } = await supabase
      .from('blocked_times')
      .insert([{
        installer_id: installer.id,
        block_date: format(date, 'yyyy-MM-dd'),
        start_time: startTime,
        end_time: endTime,
        reason: reason || null
      }]);

    if (error) {
      console.error('Error blocking time:', error);
      alert('Failed to block time');
      setLoading(false);
      return;
    }

    onClose();
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Block Time</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="flex items-center gap-2 p-3 bg-slate-50 rounded">
            <Calendar className="w-4 h-4 text-slate-600" />
            <span className="font-medium">{format(date, 'EEEE, MMMM d, yyyy')}</span>
          </div>

          <div className="flex items-center gap-2 p-3 bg-slate-50 rounded">
            <User className="w-4 h-4 text-slate-600" />
            <div
              className="w-3 h-3 rounded-full mr-1"
              style={{ backgroundColor: installer.color }}
            />
            <span className="font-medium">{installer.name}</span>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Start Time</Label>
              <Select value={startTime} onValueChange={setStartTime}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {timeOptions.map(time => (
                    <SelectItem key={time} value={time}>
                      {time}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label>End Time</Label>
              <Select value={endTime} onValueChange={setEndTime}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {timeOptions.map(time => (
                    <SelectItem key={time} value={time}>
                      {time}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>

          <div>
            <Label>Reason (Optional)</Label>
            <Input
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="e.g., Personal appointment, vacation"
            />
          </div>

          <Button 
            onClick={handleBlock} 
            disabled={loading}
            className="w-full"
          >
            Block Time
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
